<template>
  <b-container class="ombre">
    <h1 v-html="$t('newsletter.title')"></h1>
    <b-row align-h="center">
      <b-col
        lg="8"
        xl="9"
      >
        <div v-html="$t('newsletter.intro')"></div>

        <div class="clearfix mb-2">
          <b-form
            method="post"
            name="subscribeform"
            action="https://contact.framasoft.org/php_list/lists/?p=subscribe&amp;id=2"
            class="col-md-10 bg-light mx-auto my-4 px-4 py-3 rounded border"
          >
            <b-input-group class="mb-3">
              <b-input-group-prepend>
                <!-- Only decorative-->
                <b-button
                  aria-hidden="true"
                  class="disabled"
                >
                  <svg-icon
                    name="r-envelope"
                    size="lg"
                    variant="fc-g1"
                  />
                </b-button>
                <label
                  class="sr-only"
                  for="nl-email"
                  v-html="$t('newsletter.your-email')"
                ></label>
              </b-input-group-prepend>
              <b-form-input
                id="nl-email"
                v-model="email"
                name="email"
                type="email"
                size="40"
                :title="$t('newsletter.type-your-email')"
                :placeholder="$t('newsletter.your-email')"
              />
            </b-input-group>
            <div class="text-right">
              <Unsubscribe :email="email" />
              <b-button
                variant="primary"
                name="subscribe"
                type="submit"
                value="subscribe"
              >
                <svg-icon
                  :label="$t('newsletter.subscribe')"
                  name="bell"
                  variant="fc-f1"
                />
              </b-button>
            </div>
            <input
              name="htmlemail"
              value="1"
              type="hidden"
            />
            <input
              name="list[5]"
              value="signup"
              type="hidden"
            />
            <input
              name="listname[5]"
              value="Newsletter"
              type="hidden"
            />
            <div style="display: none;">
              <input
                name="VerificationCodeX"
                size="20"
                value=""
                aria-hidden="true"
                type="text"
              />
            </div>
          </b-form>
        </div>
        <p v-html="$t('newsletter.nb')"></p>
      </b-col>
    </b-row>
    <b-row id="archives">
      <b-col>
        <h2 v-html="$t('newsletter.archives')"></h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        v-for="(yearnl, index) in nl"
        :key="index"
        lg="6"
        class="mb-4"
      >
        <h3 v-html="yearnl[0].substr(0,4)"></h3>
        <b-card
          no-body
          mig-top
        >
          <img
            alt=""
            class="card-img"
            :src="`${$t('baseurl')}img/nl/${yearnl[0].substr(0,4)}.jpg`"
          />
          <b-card-body>
            <b-card-text>
              <b-list-group>
                <b-list-group-item
                  v-for="day in yearnl.filter(i => !/-hs$/.test(i))"
                  :key="day"
                  :href="`${$t('/')}nl/newsletter${nlMap[day]}.html`"
                >
                  <span
                    v-html="`N°${nlMap[day]} - ${
                      (new Date(day)).toLocaleDateString($t('lang'), {
                        month: 'long'
                      })}`"
                  ></span>
                </b-list-group-item>
              </b-list-group>
              <div
                v-if="/-hs/.test(yearnl.join())"
                class="mt-2"
              >
                <b-list-group>
                  <b-list-group-item
                    v-for="day in yearnl.filter(i => /-hs$/.test(i))"
                    :key="day"
                    :href="`${$t('/')}nl/newsletterHS0${nlMap[day]}.html`"
                  >
                    <span
                      v-html="`${$t('newsletter.hs')
                      } n°${nlMap[day]} - ${
                        (new Date(day.replace('-hs', ''))).toLocaleDateString($t('lang'), {
                          month: 'long'
                        })}`"
                    ></span>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </b-card-text>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<style lang="scss">
#newsletter .card-img {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
</style>

<script>
import Unsubscribe from '../partials/Unsubscribe.vue';

export default {
  components: {
    Unsubscribe,
  },

  data() {
    return {
      email: '',
      nl: [
        ['2021-07-13'],
        ['2020-12-16', '2020-09-04', '2020-05-06'],
        ['2019-12-09', '2019-10-16'],
        ['2018-12-01', '2018-10-29', '2018-07-02', '2018-05-05', '2018-01-25-hs'],
        ['2017-12-13', '2017-10-14', '2017-09-28-hs', '2017-06-01', '2017-03-24'],
        ['2016-12-16', '2016-10-14', '2016-06-18', '2016-04-06'],
        ['2015-12-10', '2015-10-28'],
        /* not found
        '2015-06-23', '2015-04-01'],
        ['2014-10-24', '2014-06-30'],
        ['2011-12-02', '2011-06-07'],
        ['2010-12-13'], */
      ],
      nlMap: {},
    };
  },

  created() {
    const i = {
      nl: this.nl.join().split(',').filter(j => !/-hs$/.test(j)).length + 7,
      hs: this.nl.join().split(',').filter(j => /-hs$/.test(j)).length,
    };

    for (let y = 0; y < this.nl.length; y += 1) {
      for (let d = 0; d < this.nl[y].length; d += 1) {
        if (!/-hs$/.test(this.nl[y][d])) {
          this.nlMap[this.nl[y][d]] = i.nl;
          i.nl -= 1;
        } else {
          this.nlMap[this.nl[y][d]] = i.hs;
          i.hs -= 1;
        }
      }
    }
  },
};
</script>
